/* import __COLOCATED_TEMPLATE__ from './reply-button-type-selector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();